import * as React from "react";
import {toastNotificationAppearance} from "../../utils/AppConstants";

interface ToastNotificationState {
    showDetails: boolean,
    text: string
}

interface ToastNotificationProps {
    delay?: number,
}

export const ToastNotification = (props: ToastNotificationProps) => {
    const [showDetails, toggleShowDetails] = React.useState(false)
    const [text, updateText] = React.useState("")
    const [appearance, setAppearance] = React.useState("info")

    React.useEffect(() => {
        document.addEventListener("showNotification", activateNotification, false);
    }, [])

    const activateNotification = (event: any) => {
        if (event.detail && event.detail.config && event.detail.config.appearance) {
            setAppearance(event.detail.config.appearance)
        }
        requestAnimationFrame(() => {
            toggleShowDetails(true)
            updateText(event.detail.message)
            setTimeout(deactivateNotification, props.delay || 4000)
        });
    };

    const deactivateNotification = () => {
        setTimeout(() => {
            requestAnimationFrame(() => {
                toggleShowDetails(false)
                updateText("")
            })
        }, 100);
    };

    if (!showDetails) return null;
    let appearanceCls = "info"
    if (appearance === toastNotificationAppearance.success.valueOf()) appearanceCls = "success"
    else if (appearance === toastNotificationAppearance.error.valueOf()) appearanceCls = "error"
    return(
        <div className={"toast-notification right-panel " + appearanceCls}>
            <div>{text}</div>
        </div>
    )
}